// extracted by mini-css-extract-plugin
export default {"table":"ControlTypes_table__87Yzg","search":"ControlTypes_search__kiiWv"};